export default __webpack_public_path__ + "static/media/kquizjlptn4.c1506546.png";